var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBan = function SvgBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12.243 3.757-8.485 8.486zM8 2a6 6 0 0 0-6 6v0a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v0a6 6 0 0 0-6-6",
    clipRule: "evenodd"
  })));
};
export { SvgBan as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZGVlZWVjNWE5OGYzZWUyNGRjMDk0MDQxZTljYzFhNzYuc3ZnIjs=";